import { FileDown } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

import { Button } from "@/components/ui/button";
import { downloadPdf } from "@/lib/pdf";
import { riderSaleService } from "@/services/rider-sale";

import { RiderPayrollPdfDocument } from "./rider-payroll-pdf-document";

import type { RiderPayroll } from "@artisancode/api-types";

export function RiderPayrollPdfButton({ payroll }: { payroll: RiderPayroll }) {
  const [isGenerating, setIsGenerating] = useState(false);

  async function handleDownload() {
    setIsGenerating(true);
    try {
      const { items: sales } = await riderSaleService.list({
        payroll_id: payroll.id,
        per_page: 100,
      });
      await downloadPdf(
        <RiderPayrollPdfDocument payroll={payroll} sales={sales} />,
        `Payroll-${payroll.riderName.replace(/\s+/g, "-")}-${payroll.periodStart}.pdf`,
      );
    } catch {
      toast.error("Gagal membuat PDF payroll.");
    } finally {
      setIsGenerating(false);
    }
  }

  return (
    <Button
      type="button"
      variant="outline"
      onClick={handleDownload}
      disabled={isGenerating}
    >
      <FileDown className="mr-1.5 h-4 w-4" />
      {isGenerating ? "Membuat PDF..." : "Unduh PDF"}
    </Button>
  );
}
